import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { Button } from './ui/button';

export const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-[#0D1115] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
              GET IN <span className="text-[#30D5C8]">TOUCH</span>
            </h2>
            <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans']">
              Ready to transform your industrial projects? Let's talk.
            </p>
          </div>

          <div className="bg-[#1A2733]/50 backdrop-blur-sm border border-[#506273]/30 rounded-2xl p-8 sm:p-12">
            <div className="space-y-8">
              <div className="text-center">
                <h3 className="font-['Montserrat'] font-bold text-2xl sm:text-3xl text-[#F5F7F8] mb-8">
                  ProjectFlow™ Automations
                </h3>
              </div>

              <div className="space-y-6">
                <div className="flex items-center justify-center space-x-4 p-6 bg-[#0D1115]/50 rounded-lg hover:bg-[#0D1115]/80 transition-all duration-300 group">
                  <div className="w-12 h-12 bg-[#30D5C8]/10 rounded-lg flex items-center justify-center group-hover:bg-[#30D5C8]/20 transition-colors">
                    <Mail className="text-[#30D5C8]" size={24} />
                  </div>
                  <a
                    href="mailto:info@projectflowautomations.com"
                    className="text-[#F5F7F8] font-['Open_Sans'] text-lg hover:text-[#30D5C8] transition-colors"
                  >
                    info@projectflowautomations.com
                  </a>
                </div>

                <div className="flex items-center justify-center space-x-4 p-6 bg-[#0D1115]/50 rounded-lg">
                  <div className="w-12 h-12 bg-[#30D5C8]/10 rounded-lg flex items-center justify-center">
                    <MapPin className="text-[#30D5C8]" size={24} />
                  </div>
                  <span className="text-[#F5F7F8] font-['Open_Sans'] text-lg">
                    United States
                  </span>
                </div>
              </div>

              <div className="text-center pt-6">
                <Button
                  onClick={() => window.location.href = 'mailto:info@projectflowautomations.com'}
                  className="bg-[#30D5C8] text-[#0D1115] hover:bg-[#30D5C8]/90 font-['Montserrat'] font-bold text-lg px-8 py-6 rounded-lg"
                >
                  Send Us a Message
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};